import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const colors = {
  blueGray: "bg-blue-gray-500",
  gray: "bg-gray-500",
  brown: "bg-brown-500",
  deepOrange: "bg-deep-orange-500",
  orange: "bg-orange-500",
  amber: "bg-amber-500",
  yellow: "bg-yellow-600",
  lime: "bg-lime-500",
  lightGreen: "bg-light-green-500",
  green: "bg-green-500",
  teal: "bg-teal-500",
  cyan: "bg-cyan-500",
  lightBlue: "bg-light-blue-500",
  blue: "bg-blue-500",
  indigo: "bg-indigo-500",
  deepPurple: "bg-deep-purple-500",
  purple: "bg-purple-500",
  pink: "bg-pink-500",
  red: "bg-red-500",
};

export default function StatusCard({ color, path, title, children }) {
  return (
    <Box sx={{ width: { xs: '100%', md: '33.333%' }, px: 2, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
      <Card sx={{ width: '100%' }}>
        <CardContent>
          <Box
            sx={{
              p: 1.5,
              textAlign: 'center',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              mb: 2,
              boxShadow: 3,
              borderRadius: '50%',
              bgcolor: `${colors[color] || 'bg-gray-500'}`
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ height: 20, width: 20 }}
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d={path} />
            </svg>
          </Box>
          <Typography variant="h6" color="text.secondary">{title}</Typography>
          <Typography variant="body2" color="text.secondary">{children}</Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
